import React, { useRef, useEffect, useState } from 'react'
import { useReactToPrint } from 'react-to-print'

import {
  Botao,
  Carregando,
  Checkbox,
  IconeAtencao,
  Input
} from 'src/componentes'
import { Container as ContainerErroLayout } from 'src/componentes/erro-container-layout/styles'
import { Api } from 'src/servicos'
import { DadosCertificado } from 'src/servicos/api/sala-aula/tipos'

import { Container, ContainerBotao } from '../../shared/styles'
import SalaAulaContainer from '../container'
import { CertificadoTemplate } from './certificado-template'
import {
  Mensagem,
  ContainerConfirmacao,
  OrientacaoNome,
  PreviewViewport,
  PreviewConteudo
} from './styles'

export const Certificado: React.FC = () => {
  const certificadoRef = useRef<HTMLDivElement>(null)
  const [pronto, definirPronto] = useState(false)
  const [erro, definirErro] = useState<string | undefined>(undefined)
  const [certificado, definirCertificado] = useState<DadosCertificado>(
    {} as DadosCertificado
  )
  const [nomeExibido, definirNomeExibido] = useState('')
  const [nomeConfirmado, definirNomeConfirmado] = useState(false)
  const acaoPrint = useReactToPrint({
    content: () => certificadoRef.current
  })
  const { salaAula, idMatricula } = SalaAulaContainer.useContainer()

  const nomePreenchido = Boolean(nomeExibido.trim())
  const podeBaixar = nomePreenchido && nomeConfirmado
  const certificadoPreview: DadosCertificado = {
    ...certificado,
    nome: nomeExibido
  }

  const carregarDados = async () => {
    try {
      definirPronto(false)
      definirErro(undefined)
      definirNomeConfirmado(false)

      const dadosCertificado = await Api.SalaAulaCursoLivre.RequisitarDadosCertificado(
        idMatricula
      )

      definirCertificado(dadosCertificado)
      definirNomeExibido(dadosCertificado.nome ?? '')
    } catch {
      definirErro('Ops! Houve algum problema ao carregar o certificado')
    } finally {
      definirPronto(true)
    }
  }

  useEffect(() => {
    carregarDados()
  }, [idMatricula])

  return (
    <Container>
      {pronto && !erro ? (
        <>
          <Mensagem>
            Parabéns! Você concluiu o <strong>{salaAula.nomeCurso}</strong>.
            Confira o nome que será impresso e realize o download do seu
            certificado.
          </Mensagem>
          <ContainerConfirmacao>
            <Input
              id="ipt_nome_certificado"
              label="Nome no certificado"
              value={nomeExibido}
              maxLength={200}
              disabled={nomeConfirmado}
              onChange={evento => {
                definirNomeExibido(evento.target.value)
                definirNomeConfirmado(false)
              }}
            />
            <OrientacaoNome>
              O certificado abaixo atualiza enquanto você digita. Confirme o
              nome antes de baixar.
            </OrientacaoNome>
            <Checkbox
              texto="Confirmo que o nome está correto para emissão"
              htmlFor="chk_confirmar_nome_certificado"
              tamanho="L"
            >
              <input
                type="checkbox"
                id="chk_confirmar_nome_certificado"
                checked={nomeConfirmado}
                disabled={!nomePreenchido}
                onChange={() => definirNomeConfirmado(atual => !atual)}
              />
            </Checkbox>
          </ContainerConfirmacao>
          <PreviewViewport>
            <PreviewConteudo>
              <CertificadoTemplate
                certificado={certificadoPreview}
                ref={certificadoRef}
                dataEmissao={salaAula.dataPrimeiraGeracaoCertificado}
              />
            </PreviewConteudo>
          </PreviewViewport>
          <ContainerBotao>
            <Botao
              texto="Realizar Download do Certificado"
              onClick={acaoPrint}
              disabled={!podeBaixar}
            />
          </ContainerBotao>
        </>
      ) : !pronto && !erro ? (
        <Carregando texto="Carregando certificado ..." />
      ) : (
        <ContainerErroLayout>
          <div>
            {IconeAtencao}
            <p>{erro}</p>
            <div>
              <Botao
                tema="Padrao"
                texto="Tentar novamente"
                onClick={carregarDados}
                tamanho="S"
              />
            </div>
          </div>
        </ContainerErroLayout>
      )}
    </Container>
  )
}
